module.exports = __webpack_public_path__ + "static/media/am-17-18-may.d0ad4a21.png";